<app-exam-header [pageTitle]="'Activated Account'"></app-exam-header>
<div class="signup-container">
  <!-- Background animation elements -->
  <div class="bg-circle"></div>
  <div class="bg-circle"></div>
  <div class="bg-circle"></div>
  <div class="bg-circle"></div>
  <div class="bg-circle"></div>
  <div class="wave"></div>
  
  <div class="signup-card">
    <div class="signup-header">
      <div class="signup-badge">Registration</div>
      <h2 class="signup-title">Create Your Account</h2>
      <p class="signup-subtitle">Join us to access all features and benefits</p>
    </div>

    <form action="" [formGroup]="loginForm" class="signup-form" (ngSubmit)="onSubmit()">
      <div class="form-grid">
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">badge</mat-icon>
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" autocomplete="off">
            <mat-error *ngIf="loginForm.get('firstName')?.hasError('required')">
              First Name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">person_outline</mat-icon>
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" autocomplete="off">
            <mat-error *ngIf="loginForm.get('lastName')?.hasError('required')">
              Last Name is required
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">alternate_email</mat-icon>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" autocomplete="off">
            <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
              Email is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('email')?.hasError('pattern')">
              Enter a valid email address
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">smartphone</mat-icon>
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone" autocomplete="off" pattern="^[0-9]{10}$" maxlength="10" (keypress)="onlyNumber($event)">
            <mat-error *ngIf="loginForm.get('phone')?.hasError('required')">
              Phone Number is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('phone')?.hasError('pattern')">
              Phone Number must be 10 digits long
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">cake</mat-icon>
            <mat-label>Date Of Birth</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dob" autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="loginForm.get('dob')?.hasError('required')">
              Date of Birth is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('dob')?.hasError('minAge')">
              Minimum age is 6 years
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">business_center</mat-icon>
            <mat-label>Occupation</mat-label>
            <input matInput formControlName="occupation" autocomplete="off">
            <mat-error *ngIf="loginForm.get('occupation')?.hasError('required')">
              Occupation is required
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">lock</mat-icon>
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" autocomplete="off">
            <button mat-icon-button matSuffix (click)="togglePasswordVisibility('password')" type="button" aria-label="Toggle password visibility">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
              Password is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
              Password must be at least 8 characters long
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-field">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="field-icon">lock_outline</mat-icon>
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="cPassword" [type]="hideConfirmPassword ? 'password' : 'text'" autocomplete="off">
            <button mat-icon-button matSuffix (click)="togglePasswordVisibility('confirm')" type="button" aria-label="Toggle password visibility">
              <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="loginForm.get('cPassword')?.hasError('required')">
              Confirm Password is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('cPassword').hasError('passwordMismatch')">
              Passwords do not match
            </mat-error>
            <mat-error *ngIf="loginForm.get('cPassword')?.hasError('minlength')">
              Confirm Password must be at least 8 characters long
            </mat-error>

          </mat-form-field>
        </div> 
      </div>
      
      <div class="signup-footer">
        <button class="signup-button" [disabled]="loginForm.invalid">
          <span>Create Account</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <p class="login-link">Already have an account? <a routerLink="/login">Sign In</a></p>
      </div>
    </form>
  </div>
</div>
<app-exam-footer></app-exam-footer>